<template>
	<div
		class="w-full form-check"
		:class="classes.root"
		@click.stop.prevent="ChangeSelect"
	>
		<input
			:id="inputId"
			type="checkbox"
			:name="inputName"
			:checked="value"
			hidden
			@change="ChangeSelect"
		/>
		<label
			class="form-check-label"
			:for="inputId"
		>
		</label>
		<span
			class="flex-1 text-uppercase text-ellipsis"
			:class="classes.span"
			>{{ text }}</span
		>
	</div>
</template>

<script>
	export default {
		name: 'InputCheck',
		props: {
			inputId: {
				type: String,
				required: true,
			},
			inputName: {
				type: String,
				required: true,
			},
			text: {
				type: String,
				required: false,
			},
			value: {
				type: Boolean,
				required: true,
			},
			classes: {
				type: Object,
				default: () => ({}),
			},
		},
		model: {
			prop: 'value',
			event: 'change',
		},
		methods: {
			ChangeSelect() {
				this.$emit('change', !this.value)
			},
		},
	}
</script>

<style lang="scss" scoped>
	.form-check {
		flex-grow: 1;
		display: flex;
		align-items: center;
		gap: 0.7rem;

		input:checked ~ label:after {
			width: 1.4rem;
			height: 1.4rem;
			padding: 0.2rem 0.3rem;
			background: var(--newPrimaryBackgroundColor) !important;
		}

		.form-check-label {
			position: relative;
			width: 1.4rem;
			height: 1.4rem;
			padding: 0;

			&:before {
				width: 1.4rem;
				height: 1.4rem;
				background: var(--inputBackgroundLight);
			}
		}

		&:hover {
			label:before {
				background: var(--inputBackgroundLighter);
			}
		}

		span {
			line-height: 1;
		}
	}
</style>
